export interface CongressEPoster {
  number: number;
  titleHr: string;
  titleEn: string;
  authors: string;
}

export const congressEPosters2026: CongressEPoster[] = [
  {
    number: 1,
    titleHr:
      'Transfuzijski pragovi u onkologiji: usporedba Australije, Velike Britanije, Francuske i Hrvatske',
    titleEn:
      'Transfusion Thresholds in Oncology: A Comparison of Australia, Great Britain, France and Croatia',
    authors: 'Džajić M., Karas K., Šmit-Ivček J.'
  },
  {
    number: 2,
    titleHr: 'Onkološka skrb budućnosti: medicinska sestra u središtu personalizirane medicine',
    titleEn: 'Oncology Care of the Future: The Nurse at the Heart of Personalised Medicine',
    authors: 'Malović-Novak, V., Novak M., Dokša A., Maričić, D.'
  },
  {
    number: 3,
    titleHr: 'Burnout sindrom kod medicinskih sestara u onkologiji',
    titleEn: 'Burnout Syndrome Among Oncology Nurses',
    authors: 'Petričušić A., Žižak T., Božić D., Zubatović-Đunđenac, I.'
  },
  {
    number: 4,
    titleHr: 'Sestrinske kompetencije i izazovi u onkologiji, genetičko savjetovanje i testiranje',
    titleEn: 'Nursing Competencies and Challenges in Oncology, Genetic Counselling and Testing',
    authors: 'Jurišić D., Miličević J., Bilanović Ž.'
  },
  {
    number: 5,
    titleHr:
      'Adaptacija bolesnika i obitelji na promijenjenu percepciju vlastitog tijela nakon radikalne cistektomije: pregled literature',
    titleEn:
      'Adaptation of Patients and Their Families to Changes in Body Image Following Radical Cystectomy: A Literature Review',
    authors: 'Grm K., Vrbnjak K.'
  },
  {
    number: 6,
    titleHr: 'Umjetna inteligencija u onkološkom sestrinstvu – prijetnja ili saveznik',
    titleEn: 'Artificial Intelligence in Oncology Nursing – Threat or Ally?',
    authors: 'Slukan, M.'
  },
  {
    number: 7,
    titleHr:
      'Izazovi zdravstvene njege kod bolesnika sa Stevens-Johnsonovim sindromom nakon primjene imunoterapije: prikaz slučaja',
    titleEn:
      'Challenges in Nursing Care of Patients with Stevens-Johnson Syndrome Following Immunotherapy: A Case Report',
    authors: 'Galo-Đurek, S., Bižić, R., Ormanec, T., Čop, I., Jonjić, D.'
  },
  {
    number: 8,
    titleHr: 'Suvremeni pristupi liječenju boli kod palijativnih onkoloških bolesnika',
    titleEn: 'Contemporary Approaches to Pain Management in Palliative Oncology Patients',
    authors:
      'Hlubuček Čingel, S., Čingel, B., Medved, T., Paun, M., Strapač, J., Galić, R., Miščančuk, M., Dalić, A., Zvekić, L., Lovrić, B.'
  },
  {
    number: 9,
    titleHr: 'Pravi trenutak za palijativno liječenje onkoloških bolesnika',
    titleEn: 'The Right Time for Palliative Care in Oncology Patients',
    authors:
      'Hlubuček Čingel, S., Čingel, B., Medved, T., Kožić, M., Paun, M., Pejanović, P., Zvekić, L., Lovrić, B.'
  },
  {
    number: 10,
    titleHr: 'Hladna kapa – novi standard? Iskustva iz kliničke prakse',
    titleEn: 'Cold Cap – The New Standard? Experiences from Clinical Practice',
    authors: 'Juričić, M., Vinković, L.'
  },
  {
    number: 11,
    titleHr: 'Financijska toksičnost onkološkog liječenja – nevidljiva nuspojava bolesti',
    titleEn: 'Financial Toxicity of Cancer Treatment – The Invisible Side Effect of the Disease',
    authors: 'Grubišić, J., Mamić, E.'
  },
  {
    number: 12,
    titleHr: 'Psihosocijalni aspekti raka testisa u mladih muškaraca',
    titleEn: 'Psychosocial Aspects of Testicular Cancer in Young Men',
    authors: 'Užarević, S., Bogović, M.'
  },
  {
    number: 13,
    titleHr: 'Multidisciplinarnost u liječenju onkoloških bolesnika – rak dojke',
    titleEn: 'Multidisciplinary Approach to the Treatment of Oncology Patients – Breast Cancer',
    authors: 'Ranić, I., Bartolin, M.'
  },
  {
    number: 14,
    titleHr: 'Sindrom gornje šuplje vene – prikaz slučaja',
    titleEn: 'Superior Vena Cava Syndrome – A Case Report',
    authors: 'Hačko, T., Kralj, I., Sarić, H.'
  },
  {
    number: 15,
    titleHr:
      'Komunikacija kao temelj kvalitetne onkološke skrbi: iskustva onkoloških bolesnika u OŽB Požega',
    titleEn:
      'Communication as the Foundation of Quality Oncology Care: Experiences of Oncology Patients at Požega General Hospital',
    authors: 'Paun, M., Mamić, M., Paun, T., Hubuček Čingel, S., Čingel, B., Lovrić, B.'
  },
  {
    number: 16,
    titleHr: 'Primjena intramuskularnih injekcija velikog volumena, naša iskustva',
    titleEn: 'Administration of Large-Volume Intramuscular Injections: Our Experience',
    authors: 'Šoša, A., Končurat, S., Čulina, N., Klanac, V.'
  },
  {
    number: 17,
    titleHr: 'Primjena DIBH tehnike u radioterapiji karcinoma lijeve dojke – prikaz kliničke prakse',
    titleEn: 'Application of the DIBH Technique in Radiotherapy for Left Breast Cancer – A Clinical Practice Report',
    authors: 'Stupalo, K., Biondić, M.'
  }
];
